export default angular
  .module('st.Integrations.GoogleTasks', [])
  .service('googleTasksService', ($http, dataService, GOOGLE_TASKS) => ({
    authenticate: (params) =>
      dataService.apiRequest(null, null, true, null, $http.get, GOOGLE_TASKS.API.AUTHENTICATE, {
        params
      }),
    authenticated: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.get,
        GOOGLE_TASKS.API.AUTHENTICATED,
        {
          params
        }
      ),
    deauthenticate: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.get,
        GOOGLE_TASKS.API.DE_AUTHENTICATE,
        {
          params
        }
      )
  }))
  .constant('GOOGLE_TASKS', {
    API: {
      AUTHENTICATE: '/api/v1/integration/googleTasks/authenticate',
      AUTHENTICATED: '/api/v1/integration/googleTasks/authenticated',
      DE_AUTHENTICATE: '/api/v1/integration/googleTasks/deauthenticate'
    }
  });
